import * as React from 'react';

var _path, _path2, _path3;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUsdc = function SvgUsdc(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#2775CA",
        d: "M60 120c33.25 0 60-26.75 60-60S93.25 0 60 0 0 26.75 0 60s26.75 60 60 60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M76.5 69.5c0-8.75-5.25-11.75-15.75-13-7.5-1-9-3-9-6.5s2.5-5.75 7.5-5.75c4.5 0 7 1.5 8.25 5.25.25.75 1 1.25 1.75 1.25h4c1 0 1.75-.75 1.75-1.75v-.25c-1-5.5-5.5-9.75-11.25-10.25v-6c0-1-.75-1.75-2-2H58c-1 0-1.75.75-2 2v5.75c-7.5 1-12.25 6-12.25 12.25 0 8.25 5 11.5 15.5 12.75 7 1.25 9.25 2.75 9.25 6.75s-3.5 6.75-8.25 6.75c-6.5 0-8.75-2.75-9.5-6.5-.25-1-1-1.5-1.75-1.5h-4.25c-1 0-1.75.75-1.75 1.75v.25c1 6.25 5 10.75 13.25 12v6c0 1 .75 1.75 2 2H62c1 0 1.75-.75 2-2v-6c7.5-1.25 12.5-6.5 12.5-13.25"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M25 47.75c-7.25 19.25 2.75 41 22.25 48 .75.5 1.5 1.5 1.5 2.25v3.5c0 .5 0 .75-.25 1-.25 1-1.25 1.5-2.25 1C32.25 99 21.5 88.25 17 74.25c-7.5-23.75 5.5-49 29.25-56.5.25-.25.75-.25 1-.25 1 .25 1.5 1 1.5 2V23c0 1.25-.5 2-1.5 2.5C37 29.25 28.75 37.25 25 47.75m46.5-29c.25-1 1.25-1.5 2.25-1C87.5 22.25 98.5 33 103 47.25c7.5 23.75-5.5 49-29.25 56.5-.25.25-.75.25-1 .25-1-.25-1.5-1-1.5-2v-3.5c0-1.25.5-2 1.5-2.5C83 92.25 91.25 84.25 95 73.75c7.25-19.25-2.75-41-22.25-48-.75-.5-1.5-1.5-1.5-2.5v-3.5c0-.5 0-.75.25-1",
        clipRule: "evenodd"
    })));
};

export { SvgUsdc as ReactComponent };
//# sourceMappingURL=USDC.svg.es.js.map
